import React, { PropsWithChildren, useState } from 'react'
import * as S from './styles'

type PanelContextType = {
    open: boolean,
    toggle: React.MouseEventHandler<HTMLElement>,
    variant: Variant
}

export enum Variant {
    Default,
    Business
}

export type PanelProps = {
    variant?: Variant
}

export const PanelContext = React.createContext<PanelContextType>({open: false, toggle: () => {}, variant: Variant.Default})

export const Panel = ({children, variant = Variant.Default}: PropsWithChildren<PanelProps>) => {
    const [open, setOpen] = useState(false);

    const toggle = () => setOpen(!open);

    return (
        <PanelContext.Provider value={{open, toggle, variant}}>
            <S.Panel onClick={toggle}>
                {children}
            </S.Panel>
        </PanelContext.Provider>
    )
}